<template>
  <div>
    <a-table
      :columns="bankAccountColumns"
      :data-source="dataSource"
      :row-key="(rec, idx) => idx"
      :bordered="true"
    >
      <template #actions="{index}">
        <div>
          <a-popconfirm title="Sure to delete?" @confirm="handleRemove(index)">
            <a>
              <i class="fe fe-x-circle" />
            </a>
          </a-popconfirm>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script lang="ts">
import { ICompanyBankAccount } from '@/types/interfaces/ICompanyBankAccount'
import { defineComponent, PropType, ref } from 'vue'
const bankAccountColumns = [
  {
    title: 'A/C Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'A/C No.',
    dataIndex: 'acno',
    key: 'acno',
  },
  {
    title: 'IFSC',
    dataIndex: 'ifsc',
    key: 'ifsc',
  },
  {
    title: 'Bank Name',
    dataIndex: 'bankName',
    key: 'bankName',
  },
  {
    title: 'Branch Name',
    dataIndex: 'branchName',
    key: 'branchName',
  },
  {
    title: 'Actions',
    key: 'actions',
    slots: { customRender: 'actions' },
  },
]

export default defineComponent({
  name: 'BankAccountAddTable',
  props: {
    dataSourceProp: {
      type: Object as PropType<ICompanyBankAccount[]>,
      required: true,
    },
  },
  emits: ['onRemoveBankAccount'],
  setup(props, { emit }) {
    const dataSource = ref(props.dataSourceProp)
    const handleRemove = (index: number) => {
      emit('onRemoveBankAccount', index)
    }
    return {
      bankAccountColumns,
      dataSource,
      handleRemove,
    }
  },
})
</script>

<style scoped></style>
